import { render, staticRenderFns } from "./InformacoesPreparo.vue?vue&type=template&id=07318078&scoped=true&"
import script from "./InformacoesPreparo.vue?vue&type=script&lang=js&"
export * from "./InformacoesPreparo.vue?vue&type=script&lang=js&"
import style0 from "./InformacoesPreparo.vue?vue&type=style&index=0&id=07318078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07318078",
  null
  
)

export default component.exports